import EarnerCard from "./EarnerCard";
import useTranslator from "../../hooks/useTranslator";
import { useEffect, useState } from "react";
import { haveValue } from "../../helper/common";
import PendingGuarantorPills from "./PendingGuarantorsPill";
import { useNavigate } from "react-router-dom";
import UserPreviewCard from "./UserPreviewCard";
import PendingFlaggedGuarantors from "./PendingFlaggedGuarantors";
import { Button, Drawer, Icon } from "../design";

const GuarantorDetails = ({
  user,
  isOpen,
  onClose,
  gurantorsIncome = [],
  llShowOnly,
  isGuarantor,
  readOnly = false,
}) => {
  const { _t } = useTranslator();
  const navigate = useNavigate();
  const [pendingGuarantors, setPendingGuarantors] = useState([]);
  const [presentGuarantors, setPresentGuarantors] = useState([]);
  const [activeDropdownId, setActiveDropdownId] = useState(null);
  const [pendingDropdownId, setPendingDropdownId] = useState(null);

  useEffect(() => {
    if (haveValue(user?.gurantor_added_id)) {
      const temp_entries = user?.gurantor_added_id ?? [];

      const modifiedGuarantors = [];
      let missing = [];

      temp_entries.forEach((tempItem) => {
        const match = gurantorsIncome.find(
          (g) => g?.all_sources?._id === tempItem?.guarantor_id?._id
        );

        if (match) {
          modifiedGuarantors.push({
            ...match,
            gurantor_relation: tempItem?.gurantor_relation ?? "", // or any fields you want from tempItem
          });
        } else {
          missing.push(tempItem);
        }
      });

      if (llShowOnly) {
        missing = missing.filter(
          (item) => item.status === "present" || item.status === "processing"
        );
      }
      setPresentGuarantors(modifiedGuarantors);
      setPendingGuarantors(missing);
    }
  }, [user, gurantorsIncome]);

  const flaggedGuarantors =
    Array.isArray(user?.tenant_extra_field_id?.selected_onboarding_users) &&
    user.tenant_extra_field_id.selected_onboarding_users.filter(
      (item) => item?.type === "guarantor"
    );

  const hasGuarantors =
    pendingGuarantors?.length > 0 ||
    presentGuarantors?.length > 0 ||
    user?.gurantor_for?.length > 0 ||
    flaggedGuarantors?.length > 0;

  return (
    <Drawer
      open={!!isOpen}
      onClose={onClose}
      title={isGuarantor ? _t("guarantees") : _t("guarantors")}
      closeLabel={_t("close")}
      footer={
        !isGuarantor &&
        !llShowOnly &&
        !readOnly && (
          <Button
            size="lg"
            block
            iconStart={<Icon name="plus" />}
            onClick={() => navigate("/guarantor/onboarding")}
          >
            {_t("addGuarantor")}
          </Button>
        )
      }
    >
      <div
        className="guarantor-list"
        onClick={() => {
          setActiveDropdownId(null);
          setPendingDropdownId(null);
        }}
      >
        {hasGuarantors && (
          <div
            className={`earner-card-wrapper pending-guarantor-wrapper cus-2 ${
              llShowOnly ? "ll-show-only" : ""
            }`}
          >
            {isGuarantor
              ? user?.gurantor_for.map((data, index) => (
                  <UserPreviewCard key={index} data={data} />
                ))
              : presentGuarantors.map((data, index) => (
                  <EarnerCard
                    key={index}
                    userData={data}
                    type="guarantor"
                    onClose={onClose}
                    guarantorView={true}
                    isDropdown={activeDropdownId === data?.all_sources?._id}
                    setIsDropdown={() =>
                      setActiveDropdownId(
                        activeDropdownId === data?.all_sources?._id
                          ? null
                          : data?.all_sources?._id
                      )
                    }
                    llShowOnly={llShowOnly}
                    readOnly={readOnly}
                  />
                ))}

            {pendingGuarantors.map((data, index) => (
              <PendingGuarantorPills
                key={index}
                userData={data}
                llShowOnly={llShowOnly}
                readOnly={readOnly}
                isDropdown={pendingDropdownId === data?._id}
                setIsDropdown={() =>
                  setPendingDropdownId(
                    pendingDropdownId === data?._id ? null : data?._id
                  )
                }
              />
            ))}
            {!llShowOnly &&
              flaggedGuarantors.map((data, index) => (
                <PendingFlaggedGuarantors
                  allUsers={
                    user.tenant_extra_field_id.selected_onboarding_users
                  }
                  key={index}
                  userData={data}
                  llShowOnly={llShowOnly}
                  readOnly={readOnly}
                  isDropdown={pendingDropdownId === index}
                  setIsDropdown={() =>
                    setPendingDropdownId(
                      pendingDropdownId === index ? null : index
                    )
                  }
                />
              ))}
          </div>
        )}
      </div>
    </Drawer>
  );
};

export default GuarantorDetails;
